import React from "react";

export default function KPICard({ label, value, suffix, icon: Icon, accent }) {
  return (
    <div
      data-testid={`kpi-${String(label).toLowerCase().replace(/\s+/g, "-")}`}
      className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-sm p-5 hover-lift"
    >
      <div className="flex items-start justify-between">
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">{label}</div>
        {Icon && <Icon className="h-4 w-4 text-[hsl(var(--primary))]" />}
      </div>
      <div className="mt-3 flex items-baseline gap-1">
        <div className={`text-3xl md:text-4xl font-bold editorial-heading ${accent ? "text-[hsl(var(--accent))]" : "text-foreground"}`}>
          {value}
        </div>
        {suffix && <div className="text-sm text-muted-foreground">{suffix}</div>}
      </div>
    </div>
  );
}
